export default {
  namespaced: true,
  state     : {
    modals: [
      {
        active: false,
        type  : 'user_info',
      },
      {
        active: false,
        type  : 'user_info_admin',
      },
      {
        active: false,
        type  : 'change_password',
      },
    ],

  },
  getters: {
    user_info      : ({modals}) => modals.find( (modal) => modal.type === 'user_info'),
    user_info_admin: ({modals}) => modals.find( (modal) => modal.type === 'user_info_admin'),
    change_password: ({modals}) => modals.find( (modal) => modal.type === 'change_password'),
  },
  mutations: {
    CLOSE_MODAL(state, dialog_type) {
      state.modals.find((modal)=> modal.type === dialog_type).active = false;
    },
    OPEN_MODAL(state, dialog_type) {
      let modal = state.modals.find((modal)=> modal.type === dialog_type);
      if (!modal.active) {
        modal.active = true;
      }
    },
  },

};
